import { useState, useEffect } from 'react'

import type { MutableRefObject } from 'react'

function useScrollPosition(elementRef: MutableRefObject<HTMLDivElement | null>) {
  const [isAtTop, setIsAtTop] = useState(true)
  const [scrollTop, setScrollTop] = useState(0)

  useEffect(() => {
    let throttleTimeout: NodeJS.Timeout | null
    const handleScroll = () => {
      if (!throttleTimeout) {
        throttleTimeout = setTimeout(() => {
          throttleTimeout = null
          const element = elementRef.current
          if (element) {
            const scrollTop = element.scrollTop
            setScrollTop(scrollTop)
            if (scrollTop === 0) {
              setIsAtTop(true)
            } else {
              setIsAtTop(false)
            }
          }
        }, 100)
      }
    }

    const element = elementRef.current
    if (element) {
      element.addEventListener('scroll', handleScroll, {
        passive: false
      })
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll)
      }
    }
  }, [elementRef])

  return { isAtTop, scrollTop }
}

export default useScrollPosition
